module.exports = __webpack_public_path__ + "static/img/workSite2.94523cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/workSite2.png
// module id = iLzF
// module chunks = 1